module.exports = __webpack_public_path__ + "img/fisdaf-logo.67faa590.jpg";